import LeaderboardView from './LeaderboardView';

export default LeaderboardView;
